(() => {
  const initForm = (section) => {
    if (!section || section.dataset.bfReady === 'true') return;
    section.dataset.bfReady = 'true';

    const form = section.querySelector('form');
    if (!form) return;

    const steps = [...section.querySelectorAll('[data-bf-step]')];
    const nextBtn = section.querySelector('[data-bf-next]');
    const prevBtn = section.querySelector('[data-bf-prev]');
    const progress = section.querySelector('[data-bf-progress]');
    const currentStepLabel = section.querySelector('[data-bf-current-step]');
    const qualificationInputs = [...section.querySelectorAll('[data-bf-qualification] input[type="radio"]')];
    const qualifiedFields = section.querySelector('[data-bf-qualified-fields]');
    const disqualifiedBox = section.querySelector('[data-bf-disqualified]');
    const marketplaceChecks = [...section.querySelectorAll('[data-bf-marketplace]')];
    const marketplaceOutput = section.querySelector('[data-bf-marketplaces-output]');
    const goalChecks = [...section.querySelectorAll('[data-bf-goal]')];
    const goalsOutput = section.querySelector('[data-bf-goals-output]');

    const syncMultiValueFields = () => {
      if (marketplaceOutput) {
        marketplaceOutput.value = marketplaceChecks
          .filter((input) => input.checked)
          .map((input) => input.value)
          .join(', ');
      }

      if (goalsOutput) {
        goalsOutput.value = goalChecks
          .filter((input) => input.checked)
          .map((input) => input.value)
          .join(', ');
      }
    };

    marketplaceChecks.forEach((input) => input.addEventListener('change', syncMultiValueFields));
    goalChecks.forEach((input) => input.addEventListener('change', syncMultiValueFields));

    const updateStep = (step) => {
      steps.forEach((el) => el.classList.toggle('is-active', Number(el.dataset.bfStep) === step));
      if (progress) progress.style.width = step === 1 ? '50%' : '100%';
      if (currentStepLabel) currentStepLabel.textContent = String(step);

      const card = section.querySelector('.bf-pazaryeri-form__card');
      if (card && window.innerWidth < 990) {
        const y = card.getBoundingClientRect().top + window.scrollY - 18;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    };

    const clearInvalid = () => {
      section.querySelectorAll('.bf-is-invalid').forEach((el) => el.classList.remove('bf-is-invalid'));
    };

    const validateStep = (stepNumber) => {
      clearInvalid();
      const step = section.querySelector(`[data-bf-step="${stepNumber}"]`);
      if (!step) return true;

      const required = [...step.querySelectorAll('[required]')].filter((input) => !input.disabled && input.offsetParent !== null);
      const radioNames = new Set();
      let firstInvalid = null;

      required.forEach((input) => {
        if (input.type === 'radio') {
          if (radioNames.has(input.name)) return;
          radioNames.add(input.name);
          const group = [...step.querySelectorAll(`input[type="radio"][name="${CSS.escape(input.name)}"]`)];
          if (!group.some((radio) => radio.checked)) {
            const wrapper = input.closest('.bf-pazaryeri-form__choices');
            wrapper?.classList.add('bf-is-invalid');
            firstInvalid ||= wrapper || input;
          }
        } else if (!input.checkValidity()) {
          input.classList.add('bf-is-invalid');
          firstInvalid ||= input;
        }
      });

      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      return true;
    };

    const syncQualification = () => {
      const selected = qualificationInputs.find((input) => input.checked);
      const disqualified = selected?.hasAttribute('data-bf-disqualify');

      if (disqualifiedBox) disqualifiedBox.hidden = !disqualified;
      if (qualifiedFields) qualifiedFields.hidden = Boolean(disqualified);
    };

    qualificationInputs.forEach((input) => input.addEventListener('change', syncQualification));

    nextBtn?.addEventListener('click', () => {
      const selected = qualificationInputs.find((input) => input.checked);
      if (!selected) return void validateStep(1);
      if (selected.hasAttribute('data-bf-disqualify')) return void syncQualification();
      if (validateStep(1)) updateStep(2);
    });

    prevBtn?.addEventListener('click', () => updateStep(1));

    form.addEventListener('submit', (event) => {
      syncMultiValueFields();
      if (!validateStep(2)) event.preventDefault();
    });

    form.addEventListener('input', (event) => {
      event.target.classList?.remove('bf-is-invalid');
      event.target.closest?.('.bf-pazaryeri-form__choices')?.classList.remove('bf-is-invalid');
    });

    syncQualification();
    syncMultiValueFields();
  };

  const initAll = (root = document) => root.querySelectorAll?.('[data-bf-pazaryeri-form]').forEach(initForm);

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
